var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5281 15.2322L20.4539 19.158L19.1575 20.4544L15.2317 16.5286C13.8202 17.6579 12.03 18.3335 10.083 18.3335C5.52901 18.3335 1.83301 14.6375 1.83301 10.0835C1.83301 5.5295 5.52901 1.8335 10.083 1.8335C14.637 1.8335 18.333 5.5295 18.333 10.0835C18.333 12.0305 17.6574 13.8207 16.5281 15.2322ZM14.689 14.5521C15.8099 13.3969 16.4997 11.8211 16.4997 10.0835C16.4997 6.53829 13.6282 3.66683 10.083 3.66683C6.5378 3.66683 3.66634 6.53829 3.66634 10.0835C3.66634 13.6287 6.5378 16.5002 10.083 16.5002C11.8206 16.5002 13.3964 15.8104 14.5516 14.6895L14.689 14.5521Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconNew);
export default __webpack_public_path__ + "static/media/search_icon_new.7adda541e3e349265cc4347beb44a669.svg";
export { ForwardRef as ReactComponent };